type DOMElementAttributeSetup = {
  [atrributeName: string]: string | null;
};

const nonStructuralElementsTagNames = ["SCRIPT", "STYLE", "LINK", "META"];

export const getSiblingElements = (
  element: HTMLElement
) => {
  return Array.from(element.parentElement!.children).filter(
    sibling => (
      sibling !== element
      && (nonStructuralElementsTagNames.indexOf(sibling.tagName) === -1)
    )
  ) as HTMLElement[];
}

export const attributeToggler = (
  elementOrElements: HTMLElement | HTMLElement[],
  attributes: DOMElementAttributeSetup
) => {
  let attributeSetup: DOMElementAttributeSetup = attributes;
  let attributeRestoreSetup: { element: HTMLElement, attributes: DOMElementAttributeSetup }[] | null = null;

  const elements = Array.isArray(elementOrElements)
    ? elementOrElements
    : [elementOrElements];

  const apply = () => {
    if (attributeRestoreSetup === null) {
      const attributesToSet = Object.keys(attributeSetup);
      attributeRestoreSetup = [];

      elements.forEach((element) => {
        const attributes: DOMElementAttributeSetup = {};

        attributesToSet.forEach((attributeName) => {
          const attributeSetupValue = attributeSetup[attributeName];
          attributes[attributeName] = element.getAttribute(attributeName);

          if (attributeSetupValue === null) {
            element.removeAttribute(attributeName);
          }
          else if (attributeSetupValue !== undefined) {
            element.setAttribute(attributeName, attributeSetupValue);
          }
        });

        attributeRestoreSetup!.push({
          element,
          attributes,
        });
      });
    }

    return actions;
  };

  const restore = () => {
    if (attributeRestoreSetup !== null) {
      attributeRestoreSetup.forEach(({ element, attributes }) => {
        const attributeNames = Object.keys(attributes);

        attributeNames.forEach((attributeName) => {
          const attributeValue = attributes[attributeName];
          if (attributeValue === null) {
            element.removeAttribute(attributeName);
          }
          else if (attributeValue !== undefined) {
            element.setAttribute(attributeName, attributeValue);
          }
        });
      });

      attributeRestoreSetup = null;
    }

    return actions;
  };

  const actions = { apply, restore };

  return actions;
};
